<template>
  <div class="c-statistics-box">
    <div class="statistics-item" v-for="d of data" :key="d.id">
      <img class="statistics-item__icon" :src="d.icon" />
      <p class="statistics-item__number">
        <count-to ref="countTo" :end-val="d.number"/>
        <span v-if="d.extraType === 'withStr'">萬+</span>
      </p>
      <p class="statistics-item__label">{{ d.label }}</p>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import CountTo from '@/components/ForTest/CountTo.vue';

export default defineComponent({
  name: 'StatisticsBox',
  components: {
    CountTo,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';

.c-statistics-box {
  width: 100%;
  @include flex(flex-start, center, column);
}

.statistics-item {
  @include flex(center, center, column);
  width: 140px;

  &__icon {
    width: 90%;
  }

  &__number {
    height: 50px;
    @include flex(center);
    margin-top: 20px;
    @include font-style($c-assist-light-brown, 20, 500, 3.5px, 50px);
  }

  &__label {
    margin-top: 5px;
    @include font-style($c-main, 16, 500, 2px, 28px);

    height: 84px;
    text-align: center;
  }
}

@media screen and (min-width: $pc) {
  .statistics-item {
    width: 100%;

    & + & {
      margin-top: 50px;
    }

    &__icon {
      width: 170px;
      // width: 90%;
    }

    &__number {
      margin-top: 20px;
      @include font-style($c-assist-light-brown, 35, 500, 3.5px, 50px);
    }

    &__label {
      margin-top: 5px;
      @include font-important();
      height: 84px;
      text-align: center;
    }
  }
}
</style>
